










































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryShopBalanceRecordList,ShopBalancePay } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import {PriceFormat} from '@/utils/tyepconvert'
import { DateFormat } from '@/utils/date/DateUtil'

@Component({
  components: {
    VImageUpload,
  },
})
export default class WithdrawAuditDialog extends Vue {
  private show = false
  private data: any = {withdrawAmount:'',bankCardId:''}
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    newPassword: [this.requiredRule],
  }

  private DateFormat = DateFormat
  private PriceFormat = PriceFormat
  private withdrawRejectMsg = ''
  private recordList = []
  private loading = false
  private amount: any = 0 // 转账金额

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {withdrawAmount:'',bankCardId:''}
  }

  @Emit('success')
  private success() {
    // 触发
  }


  public open(data: any) {
    this.show = true
    this.data = {...data}
    let t = this.data.withdrawAmount - this.data.huifuBalacne
    if(this.data.payChannelMerhant == 'huifu' && t > 0){
      t = this.data.withdrawAmount - this.data.huifuBalacne
    } else if (this.data.payChannelMerhant == 'llpay'){
      t = this.data.withdrawAmount - this.data.llpayBalacne
    } else {
      t = 0
    }
    console.log(this.data.payChannelMerhant)
    console.log(this.data.llpayBalacne)
    this.amount = ((t)/100).toFixed(2)

    this.loadRecord()
  }

  public get payChannelMerhantName(){
    if(this.data.payChannelMerhant == 'huifu'){
      return "汇付支付"
    } else if(this.data.payChannelMerhant == 'llpay'){
      return "连连支付"
    }
    return "无"
  }
  private outShopIdFormat(v: any){
    if(v == '0'){
      return "平台/直营店铺"
    }
    return v
  }
  private loadRecord(){
    this.loading = true
    QueryShopBalanceRecordList({inShopId: this.data.shopId,startRow:0,limit: 100}).then(res=>{
      this.recordList = res.list
      this.loading = false
    }).catch(()=>{
      this.$message.error("查询失败")
      this.loading = false
    })
  }

  public async pay() {
    this.$confirm('是否向店铺【'+this.data.shopName+'】转账'+this.amount+'元? 当前支付渠道为【'+this.payChannelMerhantName+'】', '提示', {
      type: 'warning'
    }).then(() => {
      ShopBalancePay({
        payChannelMerhant: this.data.payChannelMerhant,
        outShopId: 0,
        inShopId: this.data.shopId,
        amount: (this.amount * 100).toFixed(0)
      }).then(res=>{
        if(res){
          this.$message.success("转账成功，请刷新【账户资金明细 】")
          this.close()
          this.success()
        }
      })
    })
  }



}
